import { useIntl } from 'react-intl'
import { useFormStateContext } from '../../../../providers'
import { useWatch } from '@vtex/admin-ui-form'
import { useDrawerState } from '../../../Drawer'
import { useConditions } from '../useConditions'
import { IconHash } from '../../../../icons'
import { messages } from './messages'
import { MarketingTagsEditor } from './Editor'
import type { MarketingTags as MarketingTagsType } from 'typings'
import { MarketingTagsView } from './View'

interface Props {
  name: string
}

export function MarketingTags(props: Props) {
  const { name } = props
  const { $t } = useIntl()

  const { form } = useFormStateContext()
  const config: MarketingTagsType | undefined = useWatch({ form, name })

  const editorState = useDrawerState()

  useConditions({
    name,
    onEdit: editorState.show,
    label: $t(messages.title),
    icon: <IconHash />,
  })

  const handleRemove = () => form.setValue(name, undefined)

  const handleSave = (values: MarketingTagsType | undefined) =>
    form.setValue(name, values)

  return (
    <>
      <MarketingTagsView
        config={config}
        onEdit={editorState.show}
        onRemove={handleRemove}
      />
      <MarketingTagsEditor
        state={editorState}
        initialConfig={config}
        onSave={handleSave}
      />
    </>
  )
}
